/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import AdvImg from '@components/AdvImg'
import { SportTalkPreviewBtn } from '@views/Matchup/MatchField/PreMatchPage/index.style'
import { MATCH_INSIGHT_TYPE, SPORT_ISSUE_TYPE } from '@v2/constants/sport-issue'
import popularSearchSlideImg from '@assets/images/bg/sport-issue-popular-search-slide.jpg'
import { YouTubeEmbed } from 'react-social-media-embed'
import { Schema$SportIssue } from '@interface/sport-issue'

// sportTalkInfo: 테스트를 위해 작성한 더미 데이터입니다. [이슈링크](https://task.zempublic.co.kr/view.php?id=9858)
// const sportTalkInfo = {
//   id: 0,
//   sportIssueType: SPORT_ISSUE_TYPE.MATCH_INSIGHT,
//   sportInfoType: MATCH_INSIGHT_TYPE.URL,
//   image: 'https://www.jejunews.com/news/photo/201402/1653940_90389_219.jpg',
//   url: 'https://youtu.be/xDQfaFUxyi8?si=6sFrPc6Km9gGablk',
//   content: '누구든지 체포 또는 구속을 당한 때에는 적부의 심사를 법원에 청구할 권리를 가진다. 제1항의 해임건의는 국회재적의원 3분의 1 이상의 발의에 의하여 국회재적의원 과반수의 찬성이 있어야 한다. 국가안전보장회의는 대통령이 주재한다. 국회는 의장 1인과 부의장 2인을 선출한다. 훈장등의 영전은 이를 받은 자에게만 효력이 있고, 어떠한 특권도 이에 따르지 아니한다.',
// }

interface SportTalkPreviewProps {
  sportIssue: Schema$SportIssue
  onClick: () => void,
  isGray?: boolean,
}

const SportTalkIssuePreview: React.FC<SportTalkPreviewProps> = observer((props) => {
  const { sportIssue, onClick, isGray } = props
  const { sportIssueType, content } = sportIssue

  let previewElem: JSX.Element

  if (sportIssueType === SPORT_ISSUE_TYPE.POPULAR_SEARCH_TERM_NEWS){
    previewElem = <AdvImg srcMode={'small'}
                          src={popularSearchSlideImg}
                          alt="now 이슈키워드"
                          className="preview-img"
                          loading={'lazy'}/>
  } else if (sportIssueType === SPORT_ISSUE_TYPE.MATCH_INSIGHT){
    const { matchInsightType, attachment } = sportIssue.matchInsight
    if (matchInsightType === MATCH_INSIGHT_TYPE.IMAGE){
      previewElem = <AdvImg srcMode={'small'}
                            src={attachment}
                            alt="now 이슈키워드"
                            className="preview-img"
                            loading={'lazy'}/>
    } else {
      previewElem = (<div className="preview-img iframe">
        <YouTubeEmbed url={attachment} width={'240px'} height={'136px'} className="preview-img"/>
      </div>)
    }
  }


  return (
    <SportTalkPreviewBtn onClick={onClick} className={isGray && 'is-gray'}>
      {previewElem}
      <p className="sport-talk-contents info">{content}</p>
    </SportTalkPreviewBtn>
  )

})
export default SportTalkIssuePreview
